export const getElementFontSize = (htmlElement: HTMLElement | null): number => {
  let fontSize = 0

  if (htmlElement) {
    fontSize = Number.parseFloat(globalThis.getComputedStyle(htmlElement).getPropertyValue('font-size'))
  }
  return fontSize
}
